import $ from 'jquery';

const logout = () => {
  // localStorage.setItem('logIn',false);

  // window.location.href = "/my-jeeva/login";

  $.ajax({
    url: "/oauth/logout",
    
    method: 'GET',
    headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
    success: function (res) {
      // Preserve Termly's cookie-consent state so users aren't re-prompted every login.
      var termlyBackup = {};
      for (var k = 0; k < localStorage.length; k++) {
        var lkey = localStorage.key(k);
        if (lkey && /termly/i.test(lkey)) {
          termlyBackup[lkey] = localStorage.getItem(lkey);
        }
      }
      localStorage.clear(); //Clear localStorage
      Object.keys(termlyBackup).forEach(function (lkey) {
        localStorage.setItem(lkey, termlyBackup[lkey]);
      });

      //Clear Cookies (but keep Termly's consent cookies)
      var allCookies = document.cookie.split(';');
      for (var i = 0; i < allCookies.length; i++) {
        var cookieName = allCookies[i].split('=')[0].trim();
        if (!cookieName || /termly/i.test(cookieName)) continue;
        document.cookie = cookieName + "=;expires="
          + new Date(0).toUTCString() + ";path=/";
      }
      window.location.href = "/my-jeeva/login";
    },
    error: function (xhr) {
      if (xhr.status == 401) {
        window.location.href = "/my-jeeva/login";
      }
    }
  });
}

export default logout;


// WEBPACK FOOTER //
// src/my-jeeva/login/Logout.js